import React from "react";
const Notfound = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <img
        src="https://i.ibb.co/k5SFSWZ/not-found.png"
        className="img-fluid"
        alt=""
      />
    </div>
  );
};

export default Notfound;
